/*
 * Copyright (c) 2023-2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import Chart from "react-apexcharts";
import debug from "../../../util/constants/Debug";

export const parsePieChartConfig = (data, scope) => {
  let chartConfig = null;
  try {
    const chartConfigCheck = data.charts.find((chart) => chart.type === scope);
    const chartData = chartConfigCheck?.data;
    if (chartData != null && Array.isArray(chartData)) {
      chartConfig = chartConfigCheck;
    }
  } catch (e) {
    debug.warn(`Failed to parse data "${data}" for scope "${scope}"`);
  } finally {
    return chartConfig;
  }
};

const PieChart = ({
  title,
  subtitle,
  data,
  nameKey = "name",
  dataKey = "value",
  dataColors,
}) => {
  const filteredData = data.filter(item => item.value);
  const categories = filteredData.map(item => item[nameKey]);
  const series = filteredData.map(item => item[dataKey]);

  const hasColors = filteredData.reduce((acc, item) => acc && item.color, true);
  const colors = hasColors ? filteredData.map(item => item.color) : null;

  // chart configuration
  const options = {
    chart: {
      type: "pie",
      animations: {
        enabled: true,
        speed: 400,
        animateGradually: {
          enabled: false,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 150
        }
      }
    },
    title: {
      text: title,
      align: "center",
      offsetX: -51,
      style: {
        fontSize: "22px",
        fontWeight: "normal",
        fontFamily: "Rubik",
      },
    },
    legend: {
      show: true,
      offsetY: 10,
      width: 102,
    },
    labels: categories,
    colors: colors ?? dataColors,
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  return (
    <div className="force-fill-container">
      <Chart className="w-100" height="100%" options={options} series={series} type="pie" />
    </div>
  );
};

export default PieChart;
